module.exports = __webpack_public_path__ + "img/q6.27da2269.jpg";